import moment from '@narvar/moment-shim';

const formatMethodDate = (date) => moment(date).format('dddd, LL');

export const mapMethodData = ({
  address_line1: street1,
  address_line2: street2,
  city,
  pickup_date: date,
  province,
  postal_code: postalCode,
}) => [
  ...(date ? [formatMethodDate(date)] : []),
  street1,
  ...(street2 ? [street2] : []),
  ...(province ? [`${city}, ${province}, ${postalCode}`] : [`${city}, ${postalCode}`]),
];

export const mapSidebarData = ({
  address_line1: street1,
  address_line2: street2,
  city,
  province,
  postal_code: postalCode,
}) => [
  street1,
  ...(street2 ? [street2] : []),
  ...(province ? [`${city}, ${province}, ${postalCode}`] : [`${city}, ${postalCode}`]),
];
